// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
  width: 100%;
}
:host a {
  color: inherit;
  text-decoration: none;
}
:host .clickable {
  cursor: pointer;
}
:host .hide-in-percy {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 50px;
}
:host {
  /* stylelint-disable-next-line */
}
:host spx-icon ::ng-deep mat-icon {
  height: 18px;
  width: 18px;
}
:host .type-icon {
  margin-right: 0.5rem;
}
/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImJyZWFkY3J1bWJzLmNvbXBvbmVudC5zY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0VBQ0UsY0FBQTtFQUNBLFdBQUE7QUFDRjtBQUNFO0VBQ0UsY0FBQTtFQUNBLHFCQUFBO0FBQ0o7QUFFRTtFQUNFLGVBQUE7QUFBSjtBQUdFO0VBQ0UsZ0JBQUE7RUFDQSx1QkFBQTtFQUNBLG1CQUFBO0VBQ0EsV0FBQTtBQURKO0FBaEJBO0VBb0JFLGdDQUFBO0FBREY7QUFFRTtFQUNFLFlBQUE7RUFDQSxXQUFBO0FBQUo7QUFHRTtFQUNFLG9CQUFBO0FBREoiLCJmaWxlIjoiYnJlYWRjcnVtYnMuY29tcG9uZW50LnNjc3MiLCJzb3VyY2VzQ29udGVudCI6WyI6aG9zdCB7XG4gIGRpc3BsYXk6IGJsb2NrO1xuICB3aWR0aDogMTAwJTtcblxuICBhIHtcbiAgICBjb2xvcjogaW5oZXJpdDtcbiAgICB0ZXh0LWRlY29yYXRpb246IG5vbmU7XG4gIH1cblxuICAuY2xpY2thYmxlIHtcbiAgICBjdXJzb3I6IHBvaW50ZXI7XG4gIH1cblxuICAuaGlkZS1pbi1wZXJjeSB7XG4gICAgb3ZlcmZsb3c6IGhpZGRlbjtcbiAgICB0ZXh0LW92ZXJmbG93OiBlbGxpcHNpcztcbiAgICB3aGl0ZS1zcGFjZTogbm93cmFwO1xuICAgIHdpZHRoOiA1MHB4O1xuICB9XG5cbiAgLyogc3R5bGVsaW50LWRpc2FibGUtbmV4dC1saW5lICovXG4gIHNweC1pY29uIDo6bmctZGVlcCBtYXQtaWNvbiB7XG4gICAgaGVpZ2h0OiAxOHB4O1xuICAgIHdpZHRoOiAxOHB4O1xuICB9XG5cbiAgLnR5cGUtaWNvbiB7XG4gICAgbWFyZ2luLXJpZ2h0OiAwLjVyZW07XG4gIH1cbn1cbiJdfQ== */`, "",{"version":3,"sources":["webpack://./libs/shared/ng/base/src/lib/base/breadcrumbs/breadcrumbs.component.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,WAAA;AACF;AACE;EACE,cAAA;EACA,qBAAA;AACJ;AAEE;EACE,eAAA;AAAJ;AAGE;EACE,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;AADJ;AAhBA;EAoBE,gCAAA;AADF;AAEE;EACE,YAAA;EACA,WAAA;AAAJ;AAGE;EACE,oBAAA;AADJ;AACA,glCAAglC","sourcesContent":[":host {\n  display: block;\n  width: 100%;\n\n  a {\n    color: inherit;\n    text-decoration: none;\n  }\n\n  .clickable {\n    cursor: pointer;\n  }\n\n  .hide-in-percy {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    width: 50px;\n  }\n\n  /* stylelint-disable-next-line */\n  spx-icon ::ng-deep mat-icon {\n    height: 18px;\n    width: 18px;\n  }\n\n  .type-icon {\n    margin-right: 0.5rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
